import { uniq } from "lodash-es";
import pluralize from "pluralize";
import * as Yup from "yup";
//#region src/Email/utils.ts
/**
*
* @param delimitedValues whitespace delimited values
* @returns array of undelimited strings
*/
function extractDelimitedValues(delimitedValues) {
	return uniq(delimitedValues.split(/\s{1,}/).filter((email) => email.length));
}
/**
*
* @param email
* @returns email is valid
*/
function isEmailValid(email) {
	return Yup.string().email("Email valid").isValidSync(email);
}
/**
*
* @param delimitedEmails whitespace delimited emails
* @returns error message describing invalid emails or null
*/
function getInvalidEmailErrorMessage(delimitedEmails) {
	const invalidEmails = extractDelimitedValues(delimitedEmails).filter((email) => {
		return !isEmailValid(email);
	});
	const errorCount = invalidEmails.length;
	if (!errorCount) return null;
	let errorMessage = `'${invalidEmails[0]}' is not a valid email`;
	if (errorCount > 1) errorMessage += `, along with ${errorCount - 1} ${pluralize("other", errorCount - 1)}`;
	return `${errorMessage}.`;
}
//#endregion
export { getInvalidEmailErrorMessage as n, isEmailValid as r, extractDelimitedValues as t };

//# sourceMappingURL=Email-h7ICsqGa.js.map